import React from 'react';
import { Alert, AlertProps } from '@mui/material';

interface InlineMessageProps {
  severity?: AlertProps['severity'];
  children: React.ReactNode;
}

export const InlineMessage: React.FC<InlineMessageProps> = ({
  severity = 'info',
  children,
}) => (
  <Alert severity={severity} sx={{ mb: 2 }}>
    {children}
  </Alert>
);

